module.exports = __webpack_public_path__ + "static/Algemene-Voorwaarden-d9b172c3205585b57c585460dbb14873.pdf";